import { render } from "./AnswerStat.vue?vue&type=template&id=0e728500&scoped=true"
import script from "./AnswerStat.vue?vue&type=script&lang=js"
export * from "./AnswerStat.vue?vue&type=script&lang=js"

import "./AnswerStat.vue?vue&type=style&index=0&id=0e728500&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e728500"]])

export default __exports__